import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ExportChats from '../../components/MainPage/modals/chatSettings/ExportChats';
const ChatSettingsRoute = () => {
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: "/manage/chats/export", component: ExportChats })));
};
export default ChatSettingsRoute;
